module.exports = {"TXTCLI_Step_N0":{"id":"TXTCLI_Step_N0","defaultMessage":"Schritt {0}"}}